import styled from 'styled-components'
import { ButtonComponent } from 'Pages/landings/newLandings/common/components'
import {
	media,
	Breakpoints,
	themeObject,
	textModels,
	wrapper,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	padding: 0px;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	${media(wrapper('padding'), Breakpoints.ms)};
	${media('align-items: center;', Breakpoints.ms)};
`
export const Block = styled.div<{ srcBanner: string }>`
	display: flex;
	flex-direction: column;
	padding: 32px 22px 24px 22px;
	position: relative;
	overflow: hidden;
	box-sizing: border-box;
	border-radius: 16px;
	margin-top: -16px;
	background: ${themeObject.colors.base.white};
	${({ srcBanner }) => media(`background-image: url(${srcBanner});`, Breakpoints.ms)}
	${media(
		'margin-top: 0px; height: 326px; padding: 44px 50% 44px 48px;' +
			'background-size: cover; background-position: center;',
		Breakpoints.ms
	)};
	${media('height: 360px; padding: 70px 50% 70px 48px;', Breakpoints.lx)};
	${media('height: 460px; padding: 110px 50% 110px 48px;', Breakpoints.xl)};
`
export const BannerMobile = styled.img`
	width: 100%;
	height: 200px;
	object-fit: cover;
	${media('display: none;', Breakpoints.ms)}
`
export const Title = styled.p`
	${textModels('heading', 'h1')}
	color: ${themeObject.colors.grey[800]};
	text-align: center;
	margin-bottom: 8px;
	${media(`text-align: start; color: ${themeObject.colors.base.white};`, Breakpoints.ms)}
`
export const SubTitle = styled.p`
	${textModels('text', 'xl', '400')}
	color: ${themeObject.colors.grey[800]};
	text-align: center;
	margin-bottom: 24px;
	${media(
		`text-align: start; color: ${themeObject.colors.base.white}; margin-bottom: 32px;`,
		Breakpoints.ms
	)}
`

export const Button = styled(ButtonComponent)`
	align-self: center;
	${media(`align-self: start;`, Breakpoints.ms)}
`
